import React from 'react';

import Icon from './Icon';

import CloseIcon from '../../images/close_red.png';

import './FileInput.css';

let FileInput = (props) => {
    const { className, children } = props;

    let attributes = {
        ...props,

        type: 'file',
        className: 'form-input-file',
    };

    delete attributes.children;

    return (
      <label className={'form-input-file-parent form-input-clickable' + (className ? ' ' + className : '')}>
        <input {...attributes} />
        {children}
      </label>
    )
};

FileInput.List = (props) => {
    const { className, files = [], onRemove } = props;

    const onClick = (index, file) =>
        () => {
            if (onRemove) {
                onRemove({
                    index,
                    file,
                });
            }
        };

    return (
        <div className={'form-input form-input-file-list' + (className ? ' ' + className : '')}>
            {files.map((file, index) =>
                <div key={index} className="form-input-file-list-item">
                    <span className="text-6 normal-color">{file.name}</span>

                    <Icon className="form-input-file-list-item-remove form-input-clickable" src={CloseIcon} onClick={onClick(index, file)} />
                </div>
            )}
        </div>
    );
};

export default FileInput;



// WEBPACK FOOTER //
// ./src/components/forms/FileInput.js